import { render, staticRenderFns } from "./ContemporaryMusic.vue?vue&type=template&id=3c83c67a&scoped=true&"
import script from "./ContemporaryMusic.vue?vue&type=script&lang=js&"
export * from "./ContemporaryMusic.vue?vue&type=script&lang=js&"
import style0 from "./ContemporaryMusic.vue?vue&type=style&index=0&id=3c83c67a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83c67a",
  null
  
)

export default component.exports